// extracted by mini-css-extract-plugin
export default {"BaseToogle":"Toogle_BaseToogle__SYWxZ"};